module.exports = __webpack_public_path__ + "static/media/maximum.93022e6a.svg";